@if (noteData) {
	@for (template of templates; track template) {
		<app-note-element [template]="template"></app-note-element>
	}
	<app-feedback-button type="NOTE"></app-feedback-button>
} @else if (isPreVisit) {
	<p>Questionnaire completion required to view pre-visit note.</p>
}


